import HouseSvg from 'assets/icons/buildings/houseSvg.svg';
import AnalyticsSvg from 'assets/icons/graphsAndData/analyticsSvg.svg';
import DashboardSvg from 'assets/icons/graphsAndData/dashboardSvg.svg';
import UserInHexagonSvg from 'assets/icons/human/userInHexagonSvg.svg';
import EVisitor from 'assets/icons/itemsAndObjects/e-visitor.svg';
import FileSvg from 'assets/icons/office/file.svg';
import ListSvg from 'assets/icons/office/listSvg.svg';
import MessageNotificationSvg from 'assets/icons/office/messageNotificationSvg.svg';
import Discount from 'assets/icons/signsAndSymbols/discount.svg';
import CalendarSvg from 'assets/icons/time/calendarSvg.svg';

type TRoute = {
  label: string;
  path: string;
  icon: string;
  disabled?: boolean;
  isVisible?: boolean;
};
type TRoutes = TRoute[];

const partnerBenefitsOnlyVisibleToThisEmails = [
  'toni_blaskovic_renter_lenio@gmail.com',
  'iva@travelsoft.hr',
];

export const getLiteMainNavigation = ({
  isNewUser,
  hasCMDBFields,
  isRenter,
  userEmail,
  isPartnerBenefitsVisible,
}: {
  isNewUser?: boolean;
  hasCMDBFields?: boolean;
  isRenter?: boolean;
  userEmail?: string;
  isPartnerBenefitsVisible?: boolean;
}) => {
  const routes: TRoutes = [
    {
      label: 'Dashboard',
      path: '/accommodations/dashboard',
      icon: DashboardSvg,
      disabled: !!isNewUser,
    },
    {
      label: 'Calendar',
      path: '/accommodations/calendar',
      icon: CalendarSvg,
      disabled: !!isNewUser,
    },
    {
      label: 'Reservations',
      path: '/accommodations/reservations',
      icon: ListSvg,
      disabled: !!isNewUser,
    },
    /* {
      label: 'Guests',
      path: '/accommodations/guests',
      icon: UserInHexagonSvg,
      disabled: !!isNewUser,
    }, */
    {
      label: 'Rentals',
      path: '/accommodations/rentals',
      icon: HouseSvg,
    },
    {
      label: 'eVisitor',
      path: '/accommodations/e-visitor',
      icon: EVisitor,
      disabled: !!isNewUser,
    },
    {
      label: 'Comments',
      path: '/accommodations/comments',
      icon: MessageNotificationSvg,
      disabled: !!isNewUser,
    },
    {
      label: 'Analytics',
      path: '/accommodations/analytics',
      icon: AnalyticsSvg,
      disabled: !!isNewUser,
    },
    {
      label: 'Partner benefits',
      path: '/accommodations/partner-benefits',
      icon: Discount,
      disabled: !!isNewUser,
      isVisible: isPartnerBenefitsVisible,
    },
    {
      label: 'Documents',
      path: '/accommodations/documents',
      icon: FileSvg,
      disabled: !!isNewUser,
    },
  ];

  const ejectedPartnerBenefitRoute = routes.filter((route: TRoute) => {
    // if (!partnerBenefitsOnlyVisibleToThisEmails.includes(userEmail as string)) {
    //   return route.label !== 'Partner benefits';
    // } else {
    //   return route;
    // }
    return route;
  });

  const partnerBenefitsEVisitorEjectedRoutes = ejectedPartnerBenefitRoute.filter(
    (route: TRoute) => {
      if (isRenter && !hasCMDBFields) {
        // check for eVisitor route
        return route.label !== 'eVisitor';
      } else {
        return route;
      }
    },
  );

  return userEmail ? partnerBenefitsEVisitorEjectedRoutes : routes;
};
